export const QUOTATION = {
    SERVICE_TYPE_REVISION: 'R',
    SERVICE_TYPE_SERVICES: 'C',
    SERVICE_TYPE_RECALL: 'G'
}
